import { type FunctionComponent, } from "react";
import { n, } from "@helpers";

// export declare type DollarsProps = {
// 	// value in WEI
// 	value: () => bigint;
// 	loading?: boolean;
// }

// export const Dollars: FunctionComponent<DollarsProps> = ({
// 	value,
// 	loading = false,
// }) => {

// 	const getValue = () => (
// 		loading ? "loading..."
// 		: Intl.NumberFormat("en-us", { style: "currency", currency: "USD" }).format(n(value()))
// 	);

// 	return <span>{getValue()}</span>;
// }

export declare type DollarsProps = {
	/** value to be rendered. */
	value: BigInt | undefined;

	/** decimal precision */
	points?: number;

	/** a label that will prelude the value */
	label?: string;

	loading?: boolean;
};

export const Dollars: FunctionComponent<DollarsProps> = ({
	label,
	value,
	points = 5,
	loading,
}) => {

	typeof loading === undefined ? typeof value !== "bigint" : loading;
	const classes = [ `dollars`, ].join(" ");
	const getValue = () => {
		if(loading) return "loading...";
		return typeof value === "bigint"
		? Intl.NumberFormat("en-us", { style: "currency", currency: "USD", maximumFractionDigits: n(value) >= 1_000_000 ? 0 : 2 }).format(n(value))
		: "invalid";
	}

	return (
		<span className={classes}>
			{ label && <span className="label">{label}</span> }
			<span className="value">{getValue()}</span>
		</span>
	);
};
